import { createSlice } from '@reduxjs/toolkit';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';

const isTokenValid = token => {
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 > Date.now() + 60000;
  } catch (error) {
    return false;
  }
};

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    token: null,
    userData: null,
    isInitialized: false,
    isAuthenticated: false,
  },
  reducers: {
    initializeAuth: state => {
      const token = Cookies.get('token');

      if (token && isTokenValid(token)) {
        state.token = token;
        try {
          const userDataStr = Cookies.get('userData');
          state.userData = userDataStr ? JSON.parse(userDataStr) : null;
          state.isAuthenticated = true;
        } catch (error) {
          console.error('Error parsing userData:', error);
          state.userData = null;
          state.isAuthenticated = false;
          Cookies.remove('token');
          Cookies.remove('userData');
        }
      } else {
        Cookies.remove('token');
        Cookies.remove('userData');
        state.token = null;
        state.userData = null;
        state.isAuthenticated = false;
      }
      state.isInitialized = true;
    },
    setAuthData: (state, action) => {
      const { token, userData } = action.payload;

      if (!isTokenValid(token)) {
        console.error('Attempting to set invalid token');
        return;
      }

      state.token = token;
      state.userData = userData;
      state.isAuthenticated = true;

      try {
        Cookies.set('token', token, {
          expires: 7,
          secure: true,
          sameSite: 'strict',
        });
        Cookies.set('userData', JSON.stringify(userData), {
          expires: 7,
          secure: true,
          sameSite: 'strict',
        });
      } catch (error) {
        console.error('Error saving auth data:', error);
      }
    },
    clearAuthData: state => {
      state.token = null;
      state.userData = null;
      state.isAuthenticated = false;
      Cookies.remove('token');
      Cookies.remove('userData');
    },
  },
});

export const { initializeAuth, setAuthData, clearAuthData } = authSlice.actions;
export default authSlice.reducer;
